<template>
  <div id="app"
       class="flex flex-col min-h-screen">
    <template v-if="sessionInitialized && canRenderCurrentRoute">
      <Header />
      <router-view/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Header from '@/components/Header.vue';
import interceptor from './interceptors';

export default {
  name: 'App',
  components: {
    Header,
  },
  data() {
    return {
      teardownInterceptor: null,
    };
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'organizationIsInactive',
      'sessionInitialized',
    ]),
    canRenderCurrentRoute() {
      return !this.organizationIsInactive || this.$route.name === 'inactive-organization';
    },
  },
  created() {
    this.teardownInterceptor = interceptor(this);
    this.initializeSession();
  },
  mounted() {
    this.$root.$on('findingsFilter', ($evt) => {
      this.$store.dispatch('addToFilterFinding', $evt);
    });
    window.addEventListener('focus', this.initializeSession);
    window.addEventListener('storage', this.handleSessionStorage);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.initializeSession);
    window.removeEventListener('storage', this.handleSessionStorage);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    if (this.teardownInterceptor) this.teardownInterceptor();
  },
  methods: {
    ...mapActions(['checkAuthentication', 'expireSession', 'fetchReports']),
    async initializeSession() {
      const status = await this.checkAuthentication();
      if (status === 'inactive' && this.$route.name !== 'inactive-organization') {
        await this.$router.replace({ name: 'inactive-organization' }).catch(() => {});
      } else if (status === 'anonymous'
        && this.$route.matched.some((route) => route.name === 'report')) {
        await this.expireSession();
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') this.initializeSession();
    },
    handleSessionStorage(event) {
      if (event.key !== 'orbital-access-token') return;
      if (event.newValue) {
        this.initializeSession();
      } else {
        this.expireSession();
      }
    },
  },
  watch: {
    async isAuthenticated(isAuthenticated) {
      if (isAuthenticated) {
        await this.fetchReports();
      }
    },
  },
};
</script>
<style lang="css">
@media print {
  body {
    display: block !important;
  }
}
</style>
